<template>
    <div class="container mb-5" v-if="records && records.data && records.total>0">
        <div class="row cstmPagination">
            <div class="col-12">
                <nav aria-label="...">
                    <ul class="pagination">
                        <li class="page-item" v-for="(links, index) in records.links" :key="index"
                            :class="{'active disabled':links.active, 'disabled':!links.url}">
                            <a class="page-link" href="javascript:void(0);" v-html="links.label"
                                @click="$emit('fetchRecord',links.url);contentScroll(scrollto)"></a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-12">
                <form @submit.prevent="submit_filter(records.path+'?page='+(pagination_page>0?pagination_page:1))">
                    <span>in total {{ records.last_page }} pages to</span> <input @keypress="NumbersOnly" type="text"
                        name="" v-model="pagination_page"> <span>page</span> <button type="submit">Confirm</button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'WePagination',
    props: {
        type:{
            default:1
        },
        scrollto: {

        },
        ppp: {
            default: 10
        },
        records: {

        },
    },
    data() {
        return {
             pagination_page:'',
            sp: this.ppp,
        }
    },
    watch: {
         async pagination_page(n){
            if (n>this.records.last_page) {
                this.pagination_page=this.records.last_page;
            }
        },
        async ppp(n) {
            this.sp = n
        },
        async sp(n) {
            this.$emit('update:ppp', n);
            if (n != this.ppp)
                this.$emit('fetchRecord')
            this.contentScroll(this.scrollto)
        }
    },
    methods: {
        submit_filter(url){
            this.contentScroll(this.scrollto);
            this.$emit('fetchRecord',url);

        }
    },

}
</script>
